import { createContext, useContext, ReactNode, useState, useEffect } from 'react';
import { useSessionStorage } from '../hooks';
import { SoDataDto, SoProductTypeSpecificDto } from '../api/apollo/types/types';
import { useParams } from 'react-router-dom';

export type SoInitialData = { data?: SoDataDto } & SoProductTypeSpecificDto
interface GeneralSoContextType {
  soId?: string;
  setSoId: (id: string | undefined) => void;
  soInitialData?: SoInitialData;
  setSoInitialData: (data: SoInitialData | undefined) => void;
  offerId?: string;
  setOfferId: (offerId: string | undefined) => void;
}

const GeneralSoContext = createContext<GeneralSoContextType | undefined>(undefined);

export const GeneralSoProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [soId, setSoId] = useState<string | undefined>(undefined);
  const { soId: urlSoId, offerId: urlOfferId } = useParams();
  const [soInitialData, setSoInitialData] = useState<SoInitialData | undefined>(undefined);
  const [offerId, setOfferId] = useState<string | undefined>(undefined);
  const { setValue, getValue } = useSessionStorage<string>('soId');
  const { setValue: setOfferIdValue, getValue: getOfferIdValue } = useSessionStorage<string>('offerId');

  useEffect(() => {
    const value = urlSoId || getValue();
    if (value) setSoId(value);
    const offerIdValue = urlOfferId || getOfferIdValue();
    if (offerIdValue) setOfferId(offerIdValue);
  }, []);

  const handleSetSoId = (id: string | undefined) => {
    setSoId(id);
    setValue(id as string);
  };

  const handleSetOfferId = (id: string | undefined) => {
    setOfferId(id);
    setOfferIdValue(id as string);
  };


  const value = {
    soId,
    setSoId: handleSetSoId,
    soInitialData,
    setSoInitialData,
    offerId,
    setOfferId: handleSetOfferId
  };

  return (
    <GeneralSoContext.Provider value={value}>
      {children}
    </GeneralSoContext.Provider>
  );
};

export const useGeneralSoContext = () => {
  const context = useContext(GeneralSoContext);
  if (!context) throw new Error('useGeneralSoContext must be used within GeneralSoProvider');
  return context;
};